import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, X } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: t('nav.home') },
    { path: '/about', label: t('nav.about') },
    { path: '/mission', label: t('nav.mission') },
    { path: '/breeders', label: t('nav.breeders') },
    { path: '/bank-info', label: t('nav.bankInfo') },
    { path: '/standard', label: t('nav.standard') },
    { path: '/articles', label: t('nav.articles') },
    { path: '/events', label: t('nav.events') },
    { path: '/organizations', label: t('nav.organizations') },
    { path: '/contact', label: t('nav.contact') }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_f40446d8-d7d2-4086-ac19-be3f085557d2/artifacts/2lbvgq55_Cane%20Corso%20Logo-05.png" 
              alt="Cane Corso Logo" 
              className="h-16 w-16 object-contain"
            />
            <div className="hidden md:block">
              <div className="text-xl font-bold text-gray-900">CANE CORSO</div>
              <div className="text-sm text-red-600">IRK DERNEĞİ TURKEY</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-red-600 text-white'
                    : 'text-gray-700 hover:bg-red-50 hover:text-red-600'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Right Side - Language Switcher & Portal Button */}
          <div className="flex items-center space-x-4">
            <LanguageSwitcher />
            <Link
              to="/portal"
              className="hidden md:block px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors font-medium"
            >
              {t('nav.memberPortal')}
            </Link>
            
            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive(item.path)
                      ? 'bg-red-600 text-white'
                      : 'text-gray-700 hover:bg-red-50 hover:text-red-600'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/portal"
                onClick={() => setIsMenuOpen(false)}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors font-medium text-center"
              >
                {t('nav.memberPortal')}
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
